import { useParams } from 'react-router-dom'
import { PreviewGuard } from '../../../components/PreviewGuard'
import { LoadingSpinner } from '../../../components/LoadingSpinner'
import { useGetWebinarBySlug } from '../../../api/contentful/contentfulQueries'
import { Header } from '../../../components/Header'
import { theme } from '../../../theme/theme'
import { ComponentLayout } from '../../../components/layouts/ComponentLayout'
import { useGetQueryParams } from '../../../hooks/useGetQueryParams'
import { SessionStorageKey, useSessionStorage } from '../../../hooks/useSessionStorage'
import { useEffect } from 'react'
import { KnowledgebankFilterProps } from './Index'
import styled from 'styled-components'

export const Webinar = () => {
  const [, setKnowledgebankFilter] = useSessionStorage<KnowledgebankFilterProps>(SessionStorageKey.KNOWLEDGEBANK_FILTER)
  const { id } = useParams()
  if (!id) throw new Error('No slug provided')
  const queryParams = useGetQueryParams(['y', 'webinar'])

  useEffect(() => {
    if (queryParams.y && queryParams.webinar) {
      setKnowledgebankFilter({
        savedScrollPosition: Number(queryParams.y),
        browserIndex: window.history.length,
      })
    }
  }, [queryParams.webinar, queryParams.y, setKnowledgebankFilter])

  const { data, isLoading } = useGetWebinarBySlug(id)
  const webinar = data?.items[0]

  if (isLoading) return <LoadingSpinner />
  if (!webinar) return <PreviewGuard />

  const { title, video } = webinar.fields

  if (!title) return <PreviewGuard />

  return (
    <>
      <Header
        title={title}
        backButtonLink="/portal/resource-center"
        backgroundColor={theme.color.plum}
        textColor={theme.color.plumLight}
      />
      {video && (
        <ComponentLayout>
          <VideoContainer>
            <video controls src={`https:${video.fields.file.url}`} />
          </VideoContainer>
        </ComponentLayout>
      )}
    </>
  )
}

const VideoContainer = styled.div`
  display: flex;
  justify-content: center;

  video {
    max-width: 100%;
    border-radius: 8px;
  }
`
